import { BaseAPIModel, fetcher } from '@weezevent/weezjs-core';
import { ArgumentError } from '../utils/errors';

/**
 * Subscription.
 *
 * @param {Object} params - Object parameter
 * @constructor
 */
export default class SubscriptionLink extends BaseAPIModel {
    fields() {
        return {
            id: { readOnly: true, primaryKey: true },
            name: {}
        };
    }

    link({ organizationId, eventId, rateGroupId, date_id }) {
        if (!organizationId || !eventId) {
            throw new ArgumentError('[Model][SubscriptionLink] organizationId and eventId are mandatory');
        }

        let url = this.constructor.getItemUrl({ id: this.id, organizationId, subscriptionId: this.subscription_id });
        url += '/link';

        return fetcher
            .post(url, {
                data: {
                    event_id: eventId,
                    category_id: rateGroupId,
                    date_id
                }
            })
            .then(({ response }) => this.constructor.fromJSON(response));
    }

    reset({ organizationId }) {
        if (!organizationId) {
            throw new ArgumentError('[Model][SubscriptionLink] organizationId is mandatory');
        }

        let url = this.constructor.getItemUrl({ id: this.id, organizationId, subscriptionId: this.subscription_id });
        url += '/reset';
        return fetcher.post(url).then(({ response }) => this.constructor.fromJSON(response));
    }

    unlink({ organizationId }) {
        if (!organizationId) {
            throw new ArgumentError('[Model][SubscriptionLink] organizationId is mandatory');
        }

        let url = this.constructor.getItemUrl({ id: this.id, organizationId, subscriptionId: this.subscription_id });
        url += '/unlink';

        return fetcher.post(url).then(({ response }) => this.constructor.fromJSON(response));
    }

    unlock({ organizationId }) {
        if (!organizationId) {
            throw new ArgumentError('[Model][SubscriptionLink] organizationId is mandatory');
        }

        let url = this.constructor.getItemUrl({ id: this.id, organizationId, subscriptionId: this.subscription_id });
        url += '/unlock';

        return fetcher.post(url).then(({ response }) => this.constructor.fromJSON(response));
    }

    delete({ organizationId }, queryParams = {}) {
        if (!organizationId) {
            throw new ArgumentError('[Model][SubscriptionLink] organizationId is mandatory');
        }

        let url = this.constructor.getItemUrl({ id: this.id, organizationId, subscriptionId: this.subscription_id });
        return fetcher.delete(url, { query: queryParams }).then(({ response }) => this.constructor.fromJSON(response));
    }

    override_dates({ organizationId, start_date_override, end_date_override }) {
        if (!organizationId) {
            throw new ArgumentError('[Model][SubscriptionLink] organizationId is mandatory');
        }

        let url = this.constructor.getItemUrl({ id: this.id, organizationId, subscriptionId: this.subscription_id });
        url += '/override_dates';

        return fetcher
            .patch(url, {
                data: {
                    start_date_override,
                    end_date_override
                }
            })
            .then(({ response }) => this.constructor.fromJSON(response));
    }

    static listUrl({ organizationId, subscriptionId }) {
        if (!organizationId) {
            throw new ArgumentError('[Model][SubscriptionLink] organizationId is mandatory');
        }

        if (!subscriptionId) {
            throw new ArgumentError('[Model][SubscriptionLink] subscriptionId is mandatory');
        }

        return `/ticket-imports/organizations/${organizationId}/subscriptions/${subscriptionId}/subscription_links`;
    }

    toOptions() {
        return {
            key: this.id,
            text: this.name,
            name: String(this.id),
            value: String(this.id)
        };
    }
}
